import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFlag, faFutbol, faMapPin, faTransgender} from '@fortawesome/free-solid-svg-icons'
import './TeamDetail.css'
import { faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import maleImage from './male.png';
import femaleImage from './female.png'

const TeamDetail = () => {

    const {teamDetail} = useParams();
    const [getTeamDetail,setTeamDetail]=useState([])

    useEffect(()=>{
        const url = `https://www.thesportsdb.com/api/v1/json/1/lookupteam.php?id=${teamDetail}`;
        fetch(url)
        .then(res => res.json())
        .then(data => setTeamDetail(data.teams[0]))
    },[teamDetail]);
    const {strTeam,strTeamBanner,intFormedYear,strCountry,strGender,strDescriptionEN,strYoutube,strFacebook,strInstagram,strTeamBadge} = getTeamDetail;
    let genderImage;
    if(strGender === 'Male'){
       genderImage =  <img className='img-fluid' src={maleImage} alt=""/>
    }
    else{
        genderImage = <img src={femaleImage} alt=""/>
    }
    return (
        <div className='container-fluid'>
            
            <div className="row">
                <div className="col-md-12">
                    <img alt='banner' className="w-100 banner-image" src={strTeamBanner}></img>
                    <img alt='logo club' className='banner-logo' src={strTeamBadge}/>
                </div>
            </div>
            
            <div className="container">
                <div className="details-box">
                    <div className="row">
                            <div className="col-md-6">
                                <div className="all-text">
                                    <h2>{strTeam}</h2>
                                    <h6><FontAwesomeIcon icon={faMapPin} />Founded : {intFormedYear}</h6>
                                    <h6><FontAwesomeIcon icon={faFlag} />Country : {strCountry}</h6>
                                    <h6><FontAwesomeIcon icon={faFutbol} />Sport type: Football</h6>
                                    <h6><FontAwesomeIcon icon={faTransgender} />Gender {strGender}</h6>
                                </div>
                                

                            </div>
                            <div className="col-md-6">
                                <div className="img-box">
                                    {genderImage}
                                </div>
                            </div>
                        </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-10">
                        <p className="description-team">
                            {strDescriptionEN}
                        </p>
                    </div>
                </div>
            </div>
            <div className="container">
                <div>
                    <div className="social-icon">
                      <a href={`https://${strFacebook}`}> <FontAwesomeIcon href={strYoutube} icon={faFacebook} /></a> 
                      <a href={`https://${strInstagram}`}> <FontAwesomeIcon icon={faInstagram} /></a> 
                        
                       <a href={`https://${strYoutube}`}> <FontAwesomeIcon icon={faYoutube} /></a>
                        
                    </div>
                </div>
            </div>
            
           
            
        </div>
    );
};

export default TeamDetail;